export default __webpack_public_path__ + "static/media/JashDP.998e46ff.jpg";